export const truncateText = (max:number, text:string, firstUpperCase:boolean = true) => {
 text = text ?? '';
  const needsTrim = text.length > max;

  const baseText = needsTrim
    ? text.slice(0, max) + '...'
    : text;

  const show = firstUpperCase && baseText
    ? baseText.charAt(0).toUpperCase() + baseText.slice(1)
    : baseText;

  return { needsTrim, show };
};

